(function () {
  const modal = document.querySelector('[data-select-model-modal]');
  if (!modal) return;

  const picker = modal.querySelector('[data-select-model-picker]');
  const brandTrigger = modal.querySelector('[data-select-trigger="brand"]');
  const modelTrigger = modal.querySelector('[data-select-trigger="model"]');
  const searchBtn = modal.querySelector('[data-select-model-submit]');
  const brandValue = modal.querySelector('[data-select-trigger="brand"] [data-field-value]');
  const modelValue = modal.querySelector('[data-select-trigger="model"] [data-field-value]');
  const pickerTitle = picker.querySelector('[data-picker-title]');
  const pickerSearch = picker.querySelector('[data-picker-search]');
  const pickerList = picker.querySelector('[data-picker-list]');
  const pickerEmpty = picker.querySelector('[data-picker-empty]');

  const state = {
    items: [],
    brands: [],
    models: [],
    brand: null,
    model: null,
    pickerType: null
  };

  function byTitle(a, b) {
    return String(a.title || '').localeCompare(String(b.title || ''), undefined, {
      numeric: true,
      sensitivity: 'base'
    });
  }

  function childrenOf(parentHandle) {
    return state.items.filter(function (item) {
      return item && item.parent === parentHandle;
    }).sort(byTitle);
  }

  function brandListFromItems(items) {
    const seen = {};
    const withParent = [];

    items.forEach(function (item) {
      if (!item || !item.handle || seen[item.handle]) return;
      if (item.parent) {
        seen[item.handle] = true;
        withParent.push(item);
      }
    });

    if (withParent.length) {
      return withParent.sort(byTitle);
    }

    const all = [];
    items.forEach(function (item) {
      if (!item || !item.handle || seen[item.handle]) return;
      seen[item.handle] = true;
      all.push(item);
    });
    return all.sort(byTitle);
  }

  function setPlaceholder(el, text, isPlaceholder) {
    el.textContent = text;
    el.classList.toggle('is-placeholder', Boolean(isPlaceholder));
  }

  function currentOptions() {
    if (state.pickerType === 'model') {
      return [{ handle: '', title: 'All', url: '' }].concat(state.models);
    }
    return state.brands;
  }

  function renderPicker() {
    const query = String(pickerSearch.value || '').trim().toLowerCase();
    const selected = state.pickerType === 'model'
      ? (state.model ? state.model.handle : '')
      : (state.brand ? state.brand.handle : '');

    const options = currentOptions().filter(function (item) {
      if (!query) return true;
      return String(item.title || '').toLowerCase().indexOf(query) !== -1;
    });

    pickerList.innerHTML = '';
    pickerEmpty.hidden = options.length > 0;

    options.forEach(function (item) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'fpf-model-picker__option' + (selected === item.handle ? ' is-active' : '');
      btn.setAttribute('data-handle', item.handle || '');
      btn.innerHTML = '<span>' + item.title + '</span><span class="fpf-model-picker__radio"></span>';
      pickerList.appendChild(btn);
    });
  }

  function openPicker(type) {
    if (type === 'model' && modelTrigger.classList.contains('is-disabled')) {
      return;
    }
    state.pickerType = type;
    pickerTitle.textContent = type === 'model' ? 'Model' : 'Brand';
    pickerSearch.value = '';
    pickerSearch.placeholder = type === 'model' ? 'Search' : 'Search';
    picker.removeAttribute('hidden');
    picker.classList.add('is-open');
    renderPicker();
    pickerSearch.focus();
  }

  function closePicker() {
    picker.classList.remove('is-open');
    picker.setAttribute('hidden', '');
    state.pickerType = null;
  }

  function setBrand(brand) {
    state.brand = brand;
    state.model = null;
    setPlaceholder(brandValue, brand ? brand.title : 'Please Select', !brand);
    state.models = brand ? childrenOf(brand.handle) : [];

    if (brand) {
      modelTrigger.classList.remove('is-disabled');
      setPlaceholder(modelValue, state.models.length ? 'Please Select' : 'All', Boolean(state.models.length));
    } else {
      modelTrigger.classList.add('is-disabled');
      setPlaceholder(modelValue, 'Please Select', true);
    }

    searchBtn.disabled = !brand;
  }

  function setModel(model) {
    state.model = model;
    if (model) {
      setPlaceholder(modelValue, model.title, false);
    } else if (state.brand) {
      setPlaceholder(modelValue, 'All', false);
    } else {
      setPlaceholder(modelValue, 'Please Select', true);
    }
  }

  function openModal() {
    modal.classList.add('is-open');
    modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    closePicker();
  }

  function closeModal() {
    closePicker();
    modal.classList.remove('is-open');
    modal.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }

  async function fetchAllCollections() {
    const items = [];
    let page = 1;
    let pages = 1;
    const preview = new URLSearchParams(window.location.search).get('preview_theme_id');

    while (page <= pages && page <= 40) {
      const url = new URL('/collections', window.location.origin);
      url.searchParams.set('view', 'collection-parents');
      url.searchParams.set('page', String(page));
      if (preview) {
        url.searchParams.set('preview_theme_id', preview);
      }

      const response = await fetch(url.toString(), {
        credentials: 'same-origin',
        headers: { Accept: 'text/html,application/json' }
      });
      const text = await response.text();
      const marked = text.match(/<!--FPF_COLLECTION_PARENTS_START-->([\s\S]*?)<!--FPF_COLLECTION_PARENTS_END-->/);
      if (!marked) {
        throw new Error('collection parents json missing');
      }
      const payload = JSON.parse(marked[1]);
      if (Array.isArray(payload.items)) {
        items.push.apply(items, payload.items);
      }
      pages = Number(payload.pages) || 1;
      page += 1;
    }

    return items;
  }

  async function ensureData() {
    if (state.items.length) return;

    const api = window.FPFCollectionParentIndex;
    if (api && typeof api.loadAll === 'function') {
      try {
        state.items = await api.loadAll();
      } catch (error) {
        state.items = [];
      }
    }

    if (!state.items.length) {
      state.items = await fetchAllCollections();
    }

    state.brands = brandListFromItems(state.items);
  }

  document.addEventListener('click', function (event) {
    const opener = event.target.closest('[data-select-model-open]');
    if (opener) {
      event.preventDefault();
      openModal();
      ensureData().catch(function () {});
      return;
    }

    if (!modal.classList.contains('is-open')) return;

    if (event.target.closest('[data-select-model-close]')) {
      closeModal();
      return;
    }

    if (event.target.closest('[data-picker-back], [data-picker-close]')) {
      event.preventDefault();
      closePicker();
      return;
    }

    const trigger = event.target.closest('[data-select-trigger]');
    if (trigger) {
      event.preventDefault();
      ensureData().then(function () {
        openPicker(trigger.getAttribute('data-select-trigger'));
      }).catch(function () {});
      return;
    }

    const option = event.target.closest('[data-handle]');
    if (option && option.closest('[data-picker-list]')) {
      const handle = option.getAttribute('data-handle');
      if (state.pickerType === 'brand') {
        const brand = state.brands.find(function (item) {
          return item.handle === handle;
        });
        setBrand(brand || null);
      } else {
        const model = state.models.find(function (item) {
          return item.handle === handle;
        });
        setModel(model || null);
      }
      closePicker();
    }
  });

  pickerSearch.addEventListener('input', renderPicker);

  searchBtn.addEventListener('click', function () {
    if (!state.brand) return;
    const target = state.model && state.model.url ? state.model : state.brand;
    if (target && target.url) {
      window.location.assign(target.url);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || !modal.classList.contains('is-open')) return;
    if (picker.classList.contains('is-open')) {
      closePicker();
      return;
    }
    closeModal();
  });
})();
